import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-covid-notifications',
  templateUrl: './covid-notifications.component.html',
  styleUrls: ['./covid-notifications.component.scss'],
})
export class CovidNotificationsComponent implements OnInit {
  dependencies = [
    {
      name: 'Agencia de Seguridad, Energía y Ambiente (ASEA)',
      image: 'https://firebasestorage.googleapis.com/v0/b/amimegustalagasolina-1f93a.appspot.com/o/dependences%2Fasea.jpg?alt=media&token=9fc08aad-bf23-47ad-a443-c8a71d45aa02',
      notifications: [
        {
          title: 'DOF: 20/03/2020',
          content: 'ACUERDO por el que se declara la suspensión de plazos y términos en los actos y procedimientos\n' +
            '              sustanciados\n' +
            '              en la Comisión Nacional de Hidrocarburos del lunes 23 de marzo al domingo 19 de abril de 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590064&fecha=20/03/2020',
        },
        {
          title: 'Página oficial: 31 de marzo de 2020',
          content: 'Asunto: Se comunican recomendaciones para la atención de la contingencia por Covid 19, en el marco de sus\n' +
            'obligaciones del Plan de Respuesta a Emergencias (PRE)',
          anchor: 'https://www.gob.mx/cms/uploads/attachment/file/544561/comunicado_regulados_coronavirus_310320_.pdf',
        },
      ],
    },
    {
      name: 'Comisión Reguladora de Energía (CRE)',
      image: 'https://firebasestorage.googleapis.com/v0/b/amimegustalagasolina-1f93a.appspot.com/o/dependences%2Fcre.jpg?alt=media&token=3f74fa7b-30fd-4b63-aae2-9d8abc2032b5',
      notifications: [
        {
          title: 'DOF: 20/03/2020',
          content: 'ACUERDO número A/010/2020 por el que se establece la suspensión de plazos y términos legales en la\n' +
            'Comisión Reguladora de Energía, como medida de prevención y combate de la propagación del coronavirus\n' +
            'COVID-19.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591262&fecha=07/04/2020',
        },
        {
          title: 'DOF: 07/04/2020',
          content: 'ACUERDO número A/014/2020 por el que se modifica el diverso número A/010/2020 por el que se establece\n' +
            'la suspensión de plazos y términos legales en la Comisión Reguladora de Energía, como medida de prevención\n' +
            'y combate de la propagación del coronavirus COVID-19, a efecto de ampliar el periodo suspensivo',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591262&fecha=07/04/2020',
        },
      ],
    },
    {
      name: 'PROFECO',
      image: 'https://firebasestorage.googleapis.com/v0/b/amimegustalagasolina-1f93a.appspot.com/o/dependences%2Fimages.jfif?alt=media&token=5653c6c7-2a32-447d-9ce0-9f7efd0c0076',
      notifications: [
        {
          title: 'DOF: 01/04/2020',
          content: 'ACUERDO por el que se reforma el Acuerdo que establece los medios de atención de quejas y procedimientos\n' +
            'en la Procuraduría Federal del Consumidor y suspende los plazos y términos que se indican, publicado el 20 de\n' +
            'marzo de 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590064&fecha=20/03/2020',
        },
        {
          title: 'Página oficial',
          content: 'Quién es quién en los combustibles',
          anchor: 'https://combustibles.profeco.gob.mx/#/',
        },
      ],
    },
    {
      name: 'Secretaría de Energía (SENER)',
      image: 'https://firebasestorage.googleapis.com/v0/b/amimegustalagasolina-1f93a.appspot.com/o/dependences%2Fsener.png?alt=media&token=43325476-1b71-484c-8934-cf79fb6895e3',
      notifications: [
        {
          title: 'DOF: 25/03/2020',
          content: 'ACUERDO por el que se establece la suspensión de plazos y términos legales en la Secretaría de Energía, como\n' +
            'medida de prevención y combate de la propagación del coronavirus COVID-19.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590427&fecha=25/03/2020',
        },
      ],
    },
    {
      name: 'Secretaría del Trabajo y Prevención Social (STPS) ',
      image: 'https://firebasestorage.googleapis.com/v0/b/amimegustalagasolina-1f93a.appspot.com/o/dependences%2Fstps.png?alt=media&token=42aaf468-8591-403f-815c-dca9ff4f1a97',
      notifications: [
        {
          title: 'DOF: 26/03/2020',
          content: 'ACUERDO por el que se establece la suspensión de plazos y términos legales en la Secretaría del Trabajo y\n' +
            'Previsión Social',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590576&fecha=26/03/2020',
        },
        {
          title: 'DOF: 17/04/2020',
          content: 'ACUERDO por el que se modifica el diverso por el que se establece la suspensión de plazos y términos legales\n' +
            'en la Secretaría del Trabajo y Previsión Social.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591883&fecha=17/04/2020',
        },
        {
          title: 'Página oficial: 27 de marzo de 2020',
          content: 'COMUNICADO Número 013/2020. Juntos por el Trabajo, iniciativa de la STPS para superar la emergencia',
          anchor: 'https://www.gob.mx/stps/prensa/comunicado-013-2020',
        },
        {
          title: 'Página oficial: 01 de abril de 2020',
          content: 'GUÍA DE ACCIÓN PARA LOS CENTROS DE TRABAJO ANTE EL COVID-19',
          anchor: 'https://www.gob.mx/cms/uploads/attachment/file/545494/GUI_A_DE_ACCIO_N_PARA_LOS_CENTROS_DE_TRABAJO_ANTE_EL_COVID-19_04_2020.pdf.pdf',
        },
        {
          title: 'Página oficial: 15 de abril de 2020',
          content: 'STPS y PROFEDET anuncian el lanzamiento de la Procuraduría Digital de Atención al Trabajador COVID-19',
          anchor: 'https://www.gob.mx/semarnat/documentos/cartilla-para-mejores-practicas-para-la-prevencion-del-covid-19-en-\n' +
            'el-manejo-de-residuos-solidos-urbanos?state=published',
        },
      ],
    },
    {
      name: 'Secretaria de Salud',
      image: 'https://www.inr.gob.mx/Descargas/NuevaImagen/SALUD_VERTICAL.jpg',
      notifications: [
        {
          title: 'DOF: 24/03/2020',
          content: 'ACUERDO por el que se establecen las medidas preventivas que se deberán implementar para la mitigación y\n' +
            'control de los riesgos para la salud que implica la enfermedad por el virus SARS-CoV2 (COVID-19).',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590339&fecha=24/03/2020',
        },
        {
          title: 'DOF: 24/03/2020',
          content: 'DECRETO por el que se sanciona el Acuerdo por el que se establecen las medidas preventivas que se deberán\n' +
            'implementar para la mitigación y control de los riesgos para la salud que implica la enfermedad por el virus\n' +
            'SARS-CoV2 (COVID-19).',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590340&fecha=24/03/2020',
        },
        {
          title: 'DOF: 27/03/2020',
          content: 'DECRETO por el que se declaran acciones extraordinarias en las regiones afectadas de todo el territorio nacional\n' +
            'en materia de salubridad general para combatir la enfermedad grave de atención prioritaria generada por el virus\n' +
            'SARS-CoV2 (COVID-19)',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590673&fecha=27/03/2020',
        },
        {
          title: 'DOF: 31/03/2020',
          content: 'ACUERDO por el que se establecen acciones extraordinarias para atender la emergencia sanitaria generada por\n' +
            'el virus SARS-CoV2',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590914&fecha=31/03/2020',
        },
        {
          title: 'DOF: 03/04/2020',
          content: 'ACUERDO por el que se establecen acciones extraordinarias que se deberán de realizar para la adquisición e\n' +
            'importación de los bienes y servicios a que se refieren las fracciones II y III del artículo Segundo del Decreto por\n' +
            'el que se declaran acciones extraordinarias en las regiones afectadas de todo el territorio nacional en materia\n' +
            'de salubridad general para combatir la enfermedad grave de atención prioritaria generada por el virus SARS-\n' +
            'CoV2 (COVID-19), publicado el 27 de marzo de 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591156&fecha=03/04/2020',
        },
        {
          title: 'DOF: 03/04/2020',
          content: 'NOTA Aclaratoria al Acuerdo por el que se establecen acciones extraordinarias para atender la emergencia\n' +
            'sanitaria generada por el virus SARS-CoV2, publicado en la edición vespertina de 31 de marzo de 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591157&fecha=03/04/2020',
        },
        {
          title: 'DOF: 06/04/2020',
          content: 'ACUERDO por el que se establecen los Lineamientos técnicos relacionados con las actividades descritas en los\n' +
            'incisos c) y e) de la fracción II del Artículo Primero del Acuerdo por el que se establecen acciones extraordinarias\n' +
            'para atender la emergencia sanitaria generada por el virus SARS-CoV2, publicado el 31 de marzo del 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591234&fecha=06/04/2020',
        },
        {
          title: 'DOF: 08/04/2020',
          content: 'FE de erratas que emite la Secretaría de Salud al Acuerdo por el que se establecen los Lineamientos Técnicos\n' +
            'relacionados con las actividades descritas en los incisos c) y e) de la fracción II del Artículo Primero del Acuerdo\n' +
            'por el que se establecen acciones extraordinarias para atender la emergencia sanitaria generada por el virus\n' +
            'SARS-CoV2, publicado el 31 de marzo de 2020, publicado el 6 de abril de 2020',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591376&fecha=08/04/2020',
        },
        {
          title: 'DOF: 21/04/2020',
          content: 'ACUERDO por el que se modifica el similar por el que se establecen acciones extraordinarias para atender la\n' +
            'emergencia sanitaria generada por el virus SARS-CoV2, publicado el 31 de marzo de 2020.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5592067&fecha=21/04/2020',
        },
      ],
    },
    {
      name: 'Secretaria de Hacienda y Crédito Público (SHCP)',
      image: 'https://upload.wikimedia.org/wikipedia/commons/7/70/LogoSAT.png',
      notifications: [
        {
          title: 'DOF: 26/03/2020',
          content: 'ACUERDO por el que se establecen las medidas temporales y extraordinarias y se suspenden algunos plazos\n' +
            'para la atención de las entidades financieras y personas sujetas a supervisión de la Comisión Nacional Bancaria\n' +
            'y de Valores, a causa del coronavirus denominado COVID-19.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590568&fecha=26/03/2020',
        },
        {
          title: 'DOF: 26/03/2020',
          content: 'ACUERDO por el que se establecen medidas temporales y extraordinarias y se suspenden algunos plazos para\n' +
            'la atención de los participantes en los Sistemas de Ahorro para el Retiro a causa del COVID-19.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5590568&fecha=26/03/2020',
        },
        {
          title: 'DOF: 07/04/2020',
          content: 'ACUERDO por el que se suspenden plazos para la atención de las instituciones y personas sujetas a supervisión\n' +
            'de la Comisión Nacional de Seguros y Fianzas, a causa del coronavirus denominado COVID-19.',
          anchor: 'https://www.dof.gob.mx/nota_detalle.php?codigo=5591240&fecha=07/04/2020',
        },
      ],
    },
  ];
  constructor() { }

  ngOnInit() {
  }

}
